import * as React from 'react';
import { TotalFatalInjuryPdoRow } from './common';
import { sortBasedOnList } from '../utils';

export type Table21Data = { [key: string]: { data: { [key: string]: Table21Row } } };

export interface ITable21Props {
  data: Table21Data;
}

interface ITable21State {
}

export interface Table21Row {
  fatal: number;
  injuryA: number;
  injuryB: number;
  injuryC: number;
  pdo: number;
  total: number;
}

const sortOrder = [
  "Not Distracted",
  "Talking/Listening",
  "Manually Operating (texting, dialing, playing game, etc.)",
  "Other Action (looking away from task, etc.)",
  "Not Stated",
  "Unknown",

  "Hands-free Mobile Phone",
  "Hand-held Mobile Phone",
  "Other Electronic Device",
  "Vehicle-Integrated Device",
  "Passenger/Other Non-Motorist",
  "External (to vehicle/non-motorist area)",
  "Other distraction(animal, food, grooming, etc)",
  "Not Stated",
  "Not Applicable (not distracted)",
  "Unknown",
];

export default class Table21 extends React.Component<ITable21Props, ITable21State> {
  public constructor(props: any) {
    super(props);
  };

  componentDidMount = () => {
  }

  public render() {
    return (
      <>
        {this.props.data ?
          <>
            <table className="ss-table summaryTable1 summaryTable21">
              <colgroup>
                <col />
                <col />
                <col span={6} style={{ width: '8.3%' }} />
              </colgroup>
              <thead>
                <tr>
                  <th rowSpan={2} colSpan={2} className="border-right-bold">
                    <div className="ss-table-header">
                      <span className="header-number">21</span>
                      <span className="header-text">DRIVER DISTRACTIONS</span>
                    </div>
                  </th>
                  <th rowSpan={2}>TOTAL</th>
                  <th rowSpan={2}>FATAL</th>
                  <th colSpan={3}>INJURY</th>
                  <th rowSpan={2}>PDO **</th>
                </tr>
                <tr>
                  <th>A*</th>
                  <th>B*</th>
                  <th>C*</th>
                </tr>
              </thead>
              <tbody>
                {Object.keys(this.props.data).map((key, index) =>
                  sortBasedOnList(this.props.data[key], sortOrder).map((key2, index2) =>
                    <tr
                      key={key2}
                      style={index > 0 && index2 === 0 ? { borderTop: '2px solid black' } : {}}
                    >
                      {index2 === 0 &&
                        <td rowSpan={Object.keys(this.props.data[key]).length}>
                          <p
                            className="atIntersectionVerticalColumnSmall"
                            style={{
                              textAlign: 'center',
                              width: '15px',
                              transform: 'rotate(270deg)',
                              position: 'relative',
                              top: '20px',
                              left: '8px',
                              margin: 0,
                            }}
                          >
                            {key}
                          </p>
                        </td>
                      }
                      <td className="border-right-bold">{key2}</td>
                      <td className="numberTotals">{this.props.data[key][key2].total}</td>
                      <td className="numberTotals">{this.props.data[key][key2].fatal}</td>
                      <td className="numberTotals">{this.props.data[key][key2].injuryA}</td>
                      <td className="numberTotals">{this.props.data[key][key2].injuryB}</td>
                      <td className="numberTotals">{this.props.data[key][key2].injuryC}</td>
                      <td className="numberTotals">{this.props.data[key][key2].pdo}</td>
                    </tr>)
                )}
              </tbody>
            </table>
          </>
          : <p>Loading...</p>}
      </>
    );
  }
}
